import { Autocomplete, Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const AyurvedaDiagnosisMaster = () => {
  const [formState, setFormState] = useState({
    id: null,
    code: "",
    vyaadhiName: "",
    classification: "",
    dosha: "",
    dooshya: "",
    srotas: "",
  });
  const [isActive, setIsActive] = useState(true);
  const [isSaama, setIsSaama] = useState(false);

  const [diagnosisData, setDiagnosisData] = useState([]);
  const [message, setMessage] = useState({});
  const [isloader, setisloader] = useState(false);
  const [EditID, setEditID] = useState(null);

  const [isDelete, setisDelete] = useState(false);
  const [deletedID, setdeletedID] = useState(null);
  const [delIDs, setdelIDs] = useState([]);
  const [CheckBoxList, setCheckBoxList] = useState([]);

  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);

  let commonDisable = CheckAccessFunc("ayurveda", "Masters", "Diagnosis", "Diagnosis Master", "SubTab")?.editAccess

  useEffect(() => {
    getDiagnosisMaster();
  }, []);

  const getDiagnosisMaster = () => {
    setisloader(true);
    RestAPIService.getAll(Serviceurls.AYURVEDA_DIAGNOSIS_MASTER)
      .then((response) => {
        if (response?.data?.status === 'success') {
          setDiagnosisData(response?.data?.data || []);
        }
        setisloader(false);
      }).catch((e) => {
        setisloader(false);
        errorMessage(e.message);
      })
  }

  const AddDiagnosis = () => {
    if (!formState.vyaadhiName) {
      return errorMessage("Please enter Vyaadhi Name");
    }
    if (!formState.classification) {
       return errorMessage("Please enter Classification Name");
    }
    if (!formState.dosha) {
       return errorMessage("Please enter Dosha Name");
    }
    if (!formState.dooshya) {
       return errorMessage("Please enter Dooshya Name");
    }
    if (!formState.srotas) {
       return errorMessage("Please enter Srotas Name");
    }
    let data = {
      code: formState.code,
      vyaadhi_name: formState.vyaadhiName,
      classification: formState.classification,
      dosha: formState.dosha,
      dooshya: formState.dooshya,
      srotas: formState.srotas,
      saama: isSaama,
      is_active: isActive
    };

    setisloader(true);
    let apiCall;
    if (EditID) {
      apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_DIAGNOSIS_MASTER);
    } else {
      apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_DIAGNOSIS_MASTER);
    }
    apiCall
      .then((response) => {
        if (response?.data?.status === 'success') {
          successMessage(response.data.message);
          clearForm();
          getDiagnosisMaster();
        }
        setisloader(false);
      }).catch((e) => {
        setisloader(false);
        errorMessage(e.message);
      })
  }

  const deleteDiagnosis = () => {
    let ID = deletedID ? [deletedID] : (delIDs || []);
    RestAPIService.delete(Serviceurls.AYURVEDA_DIAGNOSIS_MASTER + `?ids=${ID}`)
      .then((response) => {
        if (response.data.status === 'success') {
          successMessage(response.data.message);
          getDiagnosisMaster();
          setdelIDs([]);
          setCheckBoxList([]);
          setdeletedID(null);
          setisDelete(false);
        }
      }).catch((e) => {
        errorMessage(e.message);
      })
  }

  const errorMessage = (msg) => {
    setMessage({ isErrorMsg: true, isErrorMsgText: msg });
  }

  const successMessage = (msg) => {
    setMessage({ successMsg: true, successMsgText: msg });
  }

  const msgClose = () => {
    setMessage({});
  }

  const clearForm = () => {
    setFormState({
      id: null,
      code: "",
      vyaadhiName: "",
      classification: "",
      dosha: "",
      dooshya: "",
      srotas: "",
    });
    setIsActive(true);
    setIsSaama(false);
    setEditID(null);
  }

  const tableView = () => {
    const grpDelete = () => setisDelete(true);

    const gridToolBar = () => (
      <Box>
        <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
      </Box>
    );

    const handleTableCheckbox = (id) => {
      let selectedIDs = new Set(id);
      setCheckBoxList(id)
      let selectedRows = diagnosisData.filter((row) => selectedIDs.has(row.sno));
      let FinalData = []
      selectedRows.forEach((item) => FinalData.push(item.id))
      setdelIDs(FinalData)
    }

    diagnosisData?.forEach((element, index) => element.sno = index + 1)

    const columns = [
      {
        field: 'sno', headerName: 'S.No', flex: 0.05,
        renderCell: (params) => (<Typography>{params.row.sno}</Typography>)
      },
      { field: 'code', headerName: 'Code', flex: 0.1 },
      { field: 'vyaadhi_name', headerName: 'Vyaadhi', flex: 0.18 },
      { field: 'classification', headerName: 'Classification', flex: 0.13 },
      { field: 'dosha', headerName: 'Dosha', flex: 0.1 },
      { field: 'dooshya', headerName: 'Dooshya', flex: 0.1 },
      { field: 'srotas', headerName: 'Srotas', flex: 0.1 },
      { field: 'saama', headerName: 'Saama', alignItems: "center", flex: 0.1, renderCell: (params) => params.row.saama ? "✔" : "-" },
      { field: 'active', headerName: 'Status', flex: 0.1, renderCell: (params) => params.row.is_active ? "Active" : "In Active" },
      ...(commonDisable ? [{
        field: 'action', headerName: 'Action', flex: 0.05,
        renderCell: (params) => (
          <CommonEditButton onClick={() => {
            setFormState({
              code: params.row.code || "",
              vyaadhiName: params.row.vyaadhi_name || "",
              classification: params.row.classification || "",
              dosha: params.row.dosha || "",
              dooshya: params.row.dooshya || "",
              srotas: params.row.srotas || "",
            });
            setIsSaama(params.row.saama);
            setIsActive(params.row.is_active);
            setEditID(params.row.id);
          }} />
        )
      }] : [])
    ]

    return (
      <Box sx={{ height: '58vh' }}>
        <DataGrid
          checkboxSelection={commonDisable}
          selectionModel={CheckBoxList}
          onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
          rows={diagnosisData}
          columns={columns}
          getRowId={(row) => row['sno']}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          pageSizeOptions={[10, 20, 30]}
          pagination
          paginationMode="client"
          paginationModel={{
            page: page,
            pageSize: pageSize
          }}
          onPaginationModelChange={(model) => {
            setpage(model.page)
            setpageSize(model.pageSize)
          }}
          loading={isloader}
        />
      </Box>
    )
  }

  const textBox = (label, name, val, width, disable) => (
    <Box>
      <TextField
        size='small'
        name={name}
        value={val}
        disabled={disable}
        sx={{ width: width, marginRight: '1vw', marginTop: '1vw' }}
        label={label}
        inputProps={{maxlength: 50}}
        onChange={(e) => setFormState({ ...formState, [name]: e.target.value })}
        variant="outlined"
      />
    </Box>
  )

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      {/* Form Section */}
      <Box sx={{ height: '22vh', backgroundColor: "white", padding: "0.5vw" }}>
        <Box sx={{ display: 'flex',  flexWrap: "wrap", flexDirection: 'row' }}>
          {textBox("Diagnosis Code", 'code', formState?.code, '15vw', true)}
          {textBox("Vyaadhi Name *", 'vyaadhiName', formState?.vyaadhiName, '15vw', false)}
          {textBox("Classification *", 'classification', formState?.classification, '15vw', false)}
          {textBox("Dosha *", 'dosha', formState?.dosha, '15vw', false)}
          {textBox("Dooshya *", 'dooshya', formState?.dooshya, '15vw', false)}
          {textBox("Srotas *", 'srotas', formState?.srotas, '15vw', false)}
        </Box>

        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel control={<Checkbox checked={isSaama} onChange={(e) => setIsSaama(e.target.checked)} size='small' />} label={"Saama"} />
            <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} size='small' />} label={"Active"} />
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
              onClick={clearForm}>Clear</Button>
            <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw' }}
              onClick={AddDiagnosis}>{EditID ? "Update" : "Save"}</Button>
          </Box>
        </Box>
      </Box>

      {/* Table */}
      <Box sx={{ height: '57vh', marginTop: '.5vw', backgroundColor: 'white' }}>
        {tableView()}
      </Box>

      {/* Toasts */}
      {message.isErrorMsg && <ToastMsg severity={'error'} msg={message.isErrorMsgText} msgPop={msgClose} />}
      {message.successMsg && <ToastMsg severity={'success'} msg={message.successMsgText} msgPop={msgClose} />}

      {/* Delete Popup */}
      {isDelete && (
        <DeletePopup
          DeletTitle={`Are you sure you want to delete this item ?`}
          DeleteNotify={"This action cannot be undone."}
          deleteAlertPopupClose={() => setisDelete(false)}
          removeData={deleteDiagnosis}
          ButtonText={'Yes'}
        />
      )}

      {/* Loader */}
      <Loader loaderOpen={isloader} />
    </Box>
  );
};

export default AyurvedaDiagnosisMaster;
